<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';

    import QuestionSelect from '../../cmp/questionSelect';

    export default {
        data() {
            return {
                data: {
                    headTipImg: '乔诗语讲解',
                    headTipTxt: '答不出来也没事啦，我知道你的强项不在这，走，去下一处！',
                    headTipPathTxt: '前往位育斋 >>',
                    headTipPath: '/rodemap/qsy/08',

                    qText: '以下哪首诗歌是在描写御花园？',
                    errText: '以下哪首诗歌是在描写御花园',
                    okText: '以下哪首诗歌是在描写御花园',

                    answerArr: [
                        {
                            txt: '采菊东篱下<br/>悠然见南山',
                        },
                        {
                            txt: '故宫登楼名偶似<br/>远眺欲见蓬瀛洲',
                        },
                        {
                            txt: '玉树琼花蔚上林<br/>琼楼玉宇缀芳芬',
                            right: true
                        },
                    ],
                },
            };
        },
        components: {
            QuestionSelect,
        },
        created() {
        },
        computed: {},
        methods: {
            jump(event) {
                if (event) {
                } else {
                    this.$router.replace('/rodemap/qsy/08');
                }
                console.log(event, 'event');
            },
            finish(event) {
                if (event) {
                    Global.curr = {
                        ...this.data,
                        headTipImg: '',
                        headTipTxt: '',
                        headTipPath: '/rodemap/qsy/08',
                        headTipPathTxt: '前往位育斋 >>',
                        ybtxt: '不愧是你！去下个地方转转吧！',
                        textCfg: {
                            'text-align': 'center',
                        },
                        bg: '琼苑东门',
                    };
                    Global.yubi.qsy.b3 = true;
                    this.$router.replace('/yu');
                    Global.startPlay('qsy', 'scene10');
                } else {
                    Global.startPlay('qsy', 'scene11');
                }
            },
        },
    };
</script>

<style lang="scss">
    .answer-box {
        .a {
            line-height: 0.4rem !important;
        }
    }
    .head-tip-man {
        .txt {
            margin: 0 0.5rem 0 0.5rem !important;
        }
    }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/延辉阁.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
